export default __webpack_public_path__ + "static/media/Strugani 13.5890abe9.jpg";